import { render } from "./ResourceListPage.vue?vue&type=template&id=1e993d9c&scoped=true&ts=true"
import script from "./ResourceListPage.vue?vue&type=script&lang=ts"
export * from "./ResourceListPage.vue?vue&type=script&lang=ts"

import "./ResourceListPage.vue?vue&type=style&index=0&id=1e993d9c&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e993d9c"]])

export default __exports__